export default __webpack_public_path__ + "static/media/398235__pooky1__wheel-spin-click-slow-down.b9c66390.wav";